exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stiks-panel {\n  margin: 1em;\n  padding: 0.4em;\n  border-radius: 4px; }\n\n@media only screen and (max-width: 480px) {\n  .media-margin-top {\n    margin-top: 15px;\n    margin-bottom: 45px; }\n  .margin-bottom {\n    margin-bottom: 15px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/pages/devices-list/device-list.style.scss
// module id = ../../../../../src/app/pages/devices-list/device-list.style.scss
// module chunks = main